import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { theme, customStyling } from './BaseSelect.styles'

export type TOption = {
  value: string;
  label: string;
}

export type TOptionMixHtmlEvt = TOption & {
  target?: {
    value: string,
    name: string 
  }
}

export interface BaseSelectProps {
  selectedValue: string | object | null,
  fieldId: string,
  onChange: (ev: any) => void,
  onBlur?: (ev: any) => void,
  options?: TOption[],
  readonly?: boolean,
  autofocus?: boolean,
  placeholder?: string,
  showClearSelection?: boolean
}

const BaseSelect = (props: BaseSelectProps) => {
  const { selectedValue, fieldId, onChange = () => { }, onBlur = () => { }, readonly, autofocus, options = [], placeholder, showClearSelection } = props
  const { t } = useTranslation();

  const createOptions = (): [TOptionMixHtmlEvt[], TOption | unknown] => {
    let opts: TOptionMixHtmlEvt[] = [];
    if (options) {
      const placeholderOpt = {
        value: "",
        label: t("Options.clear_selection"),
        target: {
          name: fieldId,
          value: ""
        },
        isClearOption: showClearSelection
      };
      showClearSelection && opts.push(placeholderOpt);

      for (let i = 0; i < options.length; ++i) {
        const o = options[i];
        const valTransform = {
          value: o.value,
          label: t(o.label),
          target: {
            name: fieldId,
            value: o.value
          }
        }
        opts.push(valTransform);
      }
    }

    let value = selectedValue;
    for (let i = 0; i < opts.length; i++) {
      if (opts[i].value === selectedValue || opts[i].value.toString() === selectedValue) {
        value = { ...opts[i] };
      }
    }

    return [opts, value];
  };

  const [opts, value] = createOptions();

  return (
    <Select
      value={value || "default"}
      key={fieldId}
      name={fieldId}
      inputId={fieldId}
      styles={customStyling}
      options={opts}
      theme={theme}
      classNamePrefix="rs"
      menuPosition="fixed"
      onChange={onChange}
      onBlur={onBlur}
      placeholder={t(placeholder ?? "Options.default")}
      isDisabled={readonly}
      autoFocus={autofocus}
    />
  )
}

export default BaseSelect